import { AddCircleOutlineSharp, AddShoppingCart, ConfirmationNumberOutlined, CheckCircleOutlined } from "@mui/icons-material";
import { Box, Button, TextField, InputAdornment, Dialog, DialogTitle, DialogContent, DialogActions, Chip, Tooltip, Typography, Snackbar, Alert } from "@mui/material";
import { useEffect, useState, useRef } from "react";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import Articulo from "../Articulo";
import CarritoViewData from "../carrito/CarritoViewData";
import SearchComponent from "../Search";
import { CHANGE, STATUS_SALE, TYPE_SALE } from "../../helpers/enums";
import PrinterService from "../../services/printer";
import Modal from "../Modal";
import FormPaymentType from "../paymentType/FormPaymentType";
import CircularProgressCustom from "../CircularProgressCustom";
import { SelectArticles } from "../FormArticulo";
import ProductModal from "../ProductModal";
import { CarritoView } from "../carrito";
import RaffleService from "../../services/raffle";
import PaymentTypesService from "../../services/paymentTypes";
import { ccyFormat } from "../../helpers/helper";
import { distributeLineAmounts } from "../../helpers/payments";

const NewSale = ({ store, backgroundColor, onSearch, users, articulos = [], salesReserved = [], onCancel, onCompleteSell, onNewSale, hasModal = false, loading, initialName = '', existingItems: providedExistingItems = null }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const nameFieldRef = useRef(null);
  const [newSale, setNewSale] = useState(false);
  //const [articulosLocal, setArticulosLocal] = useState(articulos);
  const [articleInCart, setArticleInCart] = useState([]);
  const [saving, setSaving] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [dataSale, setDataSale] = useState({});
  const [moreOneArticle, setMoreOneArticle] = useState(false);
  const [searchFocusTrigger, setSearchFocusTrigger] = useState(0);
  const [variantDialog, setVariantDialog] = useState(null); // { article }
  const [selectedColor, setSelectedColor] = useState('');
  const [selectedSize, setSelectedSize] = useState('');
  const [activeLote, setActiveLote] = useState(null);
  const [rifaDialog, setRifaDialog] = useState(false);
  const [rifaData, setRifaData] = useState({ numero_rifa: '', dni: '', telefono: '' });
  const [rifaLoading, setRifaLoading] = useState(false);
  const [rifaError, setRifaError] = useState('');
  const [paymentTypes, setPaymentTypes] = useState([]);

  const existingItems = initialName
    ? (providedExistingItems || (salesReserved || []).filter((sale) => sale.nameSale === initialName))
    : [];

  const mapPaymentTypesToForm = (items = []) =>
    (items || []).map((pt) => ({
      _id: pt?._id,
      name: pt?.name || 'Medio de pago',
      description: pt?.description || '',
      applies_surcharge: Boolean(pt?.applies_surcharge),
      installments: Array.isArray(pt?.installments) ? pt.installments : [],
      amount: 0,
    }));

  const getPaymentTypesForForm = () => {
    return structuredClone(paymentTypes);
  };

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === 'F2') {
        console.log('F2 presionada');
        event.preventDefault(); // Opcional: evita el comportamiento por defecto
        setNewSale(!newSale)
      }
    };

    window.addEventListener('keydown', handleKeyDown);

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [])

  useEffect(() => {
    if (initialName) {
      setNewSale(true);
    }
  }, [initialName]);

  useEffect(() => {
    if (articulos && articulos.length === 1) {
      articulos.forEach(art => {
        addToSale(art)
      })
      setTimeout(() => {
        setSearchFocusTrigger(prev => prev + 1)
      }, 0)
      return
    }

    if (articulos?.length > 1) {
      setMoreOneArticle(true)
      return
    }

    setMoreOneArticle(false)
  }, [articulos])

  const handleSearch = (searchQuery) => {
    console.log(searchQuery)
    onSearch && onSearch(searchQuery)
  }

  // Función para calcular la mejor oferta de un artículo
  const getBestOffer = (article) => {
    if (!article.applicable_offers || article.applicable_offers.length === 0) return null;
    
    // Ordenar por prioridad (mayor primero) y tomar la primera
    const sortedOffers = [...article.applicable_offers].sort((a, b) => b.priority - a.priority);
    const bestOffer = sortedOffers[0];
    
    const price = article?.prices?.sale_price || 0;
    
    // Calcular precio final
    let finalPrice = price;
    let discountAmount = 0;
    
    if (bestOffer.type === 'percentage' && bestOffer.discount_percentage) {
      discountAmount = (price * bestOffer.discount_percentage) / 100;
      finalPrice = price - discountAmount;
    } else if (bestOffer.type === 'fixed_amount' && bestOffer.discount_amount) {
      discountAmount = bestOffer.discount_amount;
      finalPrice = price - discountAmount;
    }
    
    return {
      ...bestOffer,
      final_price: Math.max(0, finalPrice),
      discount_amount: discountAmount
    };
  };

  const addToSale = (article) => {
    const availableVariants = (article.type_detail || []).filter(v => v.available && v.quantity > 0);
    if (availableVariants.length > 0) {
      const first = availableVariants[0];
      const firstSize = (first.size_details || []).find(sd => sd.quantity > 0 && sd.available !== false)?.size
        || (first.sizes || [])[0]
        || '';
      const cartItem = buildCartItemFromArticle(article);
      cartItem.color_selected = first.color || '';
      cartItem.size_selected = firstSize;
      setArticleInCart((prevCart) => {
        const existingIndex = prevCart.findIndex(
          (item) => item.article_id === cartItem.article_id && item.prices_sold.sale_price === cartItem.prices_sold.sale_price
        );
        if (existingIndex === -1) return [...prevCart, cartItem];
        return prevCart.map((item, idx) => {
          if (idx !== existingIndex) return item;
          return {
            ...item,
            quantity_sold: item.quantity_sold + cartItem.quantity_sold,
            quantity_in_stock: Math.max(0, (item.quantity_in_stock || 0) - cartItem.quantity_sold),
            color_selected: cartItem.color_selected,
            size_selected: cartItem.size_selected,
          };
        });
      });
      return;
    }
    setArticleInCart((prevCart) => mergeArticleIntoCart(prevCart, article));
  }

  const handleConfirmVariant = () => {
    if (!variantDialog) return;
    const article = variantDialog.article;
    const cartItem = buildCartItemFromArticle(article);
    cartItem.color_selected = selectedColor;
    cartItem.size_selected = selectedSize;
    setArticleInCart((prevCart) => {
      const existingIndex = prevCart.findIndex(
        (item) => item.article_id === cartItem.article_id && item.prices_sold.sale_price === cartItem.prices_sold.sale_price
      );
      if (existingIndex === -1) {
        return [...prevCart, cartItem];
      }
      return prevCart.map((item, idx) => {
        if (idx !== existingIndex) return item;
        return {
          ...item,
          quantity_sold: item.quantity_sold + cartItem.quantity_sold,
          quantity_in_stock: Math.max(0, (item.quantity_in_stock || 0) - cartItem.quantity_sold),
          color_selected: cartItem.color_selected,
          size_selected: cartItem.size_selected,
        };
      });
    });
    setVariantDialog(null);
    setTimeout(() => setSearchFocusTrigger(prev => prev + 1), 0);
  }

  const handleCloseVariantDialog = () => {
    setVariantDialog(null);
    setTimeout(() => setSearchFocusTrigger(prev => prev + 1), 0);
  }

  const buildCartItemFromArticle = (article) => {
    // Calcular mejor oferta si tiene applicable_offers
    const bestOffer = getBestOffer(article);
    
    // Calcular precio con descuento si hay oferta aplicada
    const salePrice = bestOffer ? bestOffer.final_price : article?.prices?.sale_price;
    const originalPrice = article?.prices?.sale_price;
    
    const data = {
      store_id: store._id,
      article_id: article.article_id,
      sku: article.sku,
      quantity_in_stock: article.quantity,
      quantity_sold: 1,
      prices_sold: {
        list_price: article?.prices?.list_price,
        sale_price: salePrice
      },
      prices: {
        list_price: article?.prices?.list_price,
        sale_price: article?.prices?.sale_price
      },
      original_price: originalPrice,
      name: article.article?.name,
      description: article.article?.description,
      image: article.article?.images && article.article?.images[0],
      type_detail: article.type_detail || [],
      color_selected: '',
      size_selected: '',
      discount_applied: bestOffer ? {
        offer_id: bestOffer._id,
        offer_name: bestOffer.name,
        discount_type: bestOffer.type,
        discount_percentage: bestOffer.discount_percentage,
        discount_amount: bestOffer.discount_amount
      } : null
    }
    
    // Agregar información de descuento a la descripción si existe
    if (data.discount_applied) {
      const discountText = data.discount_applied.discount_percentage 
        ? `${data.discount_applied.discount_percentage}% OFF`
        : `$${data.discount_applied.discount_amount} OFF`;
      data.discount_description = `🏷️ ${data.discount_applied.offer_name} (${discountText})`;
    }

    data.quantity_in_stock = Math.max(0, (article.quantity || 0) - data.quantity_sold)
    return data
  }

  const mergeArticleIntoCart = (cart, article) => {
    const cartItem = buildCartItemFromArticle(article)
    const existingIndex = cart.findIndex(
      (item) => item.article_id === cartItem.article_id && item.prices_sold.sale_price === cartItem.prices_sold.sale_price
    )

    if (existingIndex === -1) {
      return [...cart, cartItem]
    }

    return cart.map((item, idx) => {
      if (idx !== existingIndex) return item

      return {
        ...item,
        quantity_sold: item.quantity_sold + cartItem.quantity_sold,
        quantity_in_stock: Math.max(0, (item.quantity_in_stock || 0) - cartItem.quantity_sold)
      }
    })
  }

  const addManyToSale = (articles = []) => {
    setArticleInCart((prevCart) =>
      articles.reduce((nextCart, article) => mergeArticleIntoCart(nextCart, article), prevCart)
    )
  }

  const handleRemoveItemFromCart = (article) => {
    var newArticleInCart = articleInCart.filter(a => a.article_id !== article.article_id ||
      (a.article_id === article.article_id && a.prices_sold.sale_price !== article.prices_sold.sale_price))
    // var art = articulos.find(a => a.article_id === article.article_id)
    // if (art) {
    //   art.quantity = art.quantity + article.quantity_sold
    //   updateStockArticle(art)
    // }
    setArticleInCart(newArticleInCart);
  }

  const handleCancel = () => {
    setNewSale(false)
    setArticleInCart([])
    setRifaData({ numero_rifa: '', dni: '', telefono: '' })
    onCancel && onCancel()
  }

  useEffect(() => {
    const loadActiveLote = async () => {
      try {
        const lotes = await RaffleService.getLotes();
        const active = (lotes || []).find((l) => l.activo);
        setActiveLote(active || null);
      } catch (err) {
        console.error(err);
      }
    };
    loadActiveLote();
  }, []);

  useEffect(() => {
    if (!store?._id) return;
    const controller = new AbortController();

    const loadPaymentTypes = async () => {
      try {
        const response = await PaymentTypesService.listByStore(store._id, { signal: controller.signal });
        if (controller.signal.aborted) return;

        const mapped = mapPaymentTypesToForm(Array.isArray(response) ? response : []);
        setPaymentTypes(mapped);
      } catch (err) {
        if (err?.name === 'CanceledError' || err?.name === 'AbortError') return;
        console.error('Error loading payment types:', err);
        setPaymentTypes([]);
      }
    };

    loadPaymentTypes();
    return () => controller.abort();
  }, [store?._id]);

  useEffect(() => {
    if (!store?._id) return;

    const unsubscribe = PaymentTypesService.subscribeToChanges(async ({ storeId }) => {
      if (storeId && storeId !== store._id) return;
      try {
        const response = await PaymentTypesService.listByStore(store._id, { forceRefresh: true });
        const mapped = mapPaymentTypesToForm(Array.isArray(response) ? response : []);
        setPaymentTypes(mapped);
      } catch (err) {
        console.error('Error refreshing payment types:', err);
      }
    });

    return () => unsubscribe();
  }, [store?._id]);

  const rifaAssigned = Boolean(rifaData.numero_rifa && rifaData.dni && rifaData.telefono);

  const handleOpenRifaDialog = async () => {
    setRifaDialog(true);
    if (!rifaData.numero_rifa && activeLote) {
      setRifaLoading(true);
      try {
        const next = await RaffleService.getNext(activeLote.lote);
        setRifaData((p) => ({ ...p, numero_rifa: next.numero }));
      } catch (err) {
        console.error(err);
      } finally {
        setRifaLoading(false);
      }
    }
  };

  const handleSell = async ({ name, delivery, vendor, deposit }) => {
    console.log('🔍 DEBUG handleSell - articleInCart:', articleInCart);
    articleInCart.forEach((item, idx) => {
      console.log(`Item ${idx}:`, {
        name: item.name,
        color_selected: item.color_selected,
        size_selected: item.size_selected
      });
    });
    
    const rifaFields = rifaAssigned ? {
      numero_rifa: Number(rifaData.numero_rifa),
      lote_rifa: activeLote?.lote,
      dni: rifaData.dni || undefined,
      telefono: rifaData.telefono || undefined,
    } : {};

    if (delivery) {
      if (!paymentTypes.length) {
        setRifaError('No hay medios de pago configurados para esta tienda.');
        return;
      }
      setOpenModal(true)
      setSaving(true)
      setDataSale({
        status: STATUS_SALE.FINISHED,
        nameSale: name,
        userId: vendor,
        deposit: deposit,
        ...rifaFields,
      })
    } else {
      var data = articleInCart.map((a) => ({
        ...a,
        quantity_in_stock: a.quantity_in_stock + a.quantity_sold,
        status: STATUS_SALE.RESERVED,
        nameSale: name,
        userId: vendor,
        deposit: deposit,
        ...rifaFields,
      }))
      console.log('🔍 DEBUG handleSell - data preparada:', data);
      setSaving(true)
      try {
        await (onCompleteSell && onCompleteSell(data))
        setArticleInCart([])
      } catch (err) {
        console.error('❌ handleSell error:', { status: err?.response?.status, data: err?.response?.data, message: err?.message });
        const errData = err?.response?.data;
        let msg;
        if (typeof errData === 'string' && errData) msg = errData;
        else if (errData?.message) msg = errData.message;
        else if (errData?.error) msg = errData.error;
        else if (errData?.detail) msg = errData.detail;
        else if (errData && typeof errData === 'object') msg = JSON.stringify(errData);
        else msg = err?.message || 'Error al guardar la venta';
        setRifaError(msg);
      } finally {
        setRifaData({ numero_rifa: '', dni: '', telefono: '' })
        setSaving(false)
      }
    }
    //setNewSale(false)
  }

  const handleFinishSell = async ({ payments }) => {
    setSaving(true)
    setOpenModal(false)
    
    console.log('🔍 DEBUG handleFinishSell - articleInCart antes de procesar:', articleInCart);
    
    articleInCart.forEach(sale => {
      if (!sale.payments) {
        sale.payments = []
      }
      var payment = payments.find(p => !p.saleIds || p.saleIds.includes(sale._id))
      sale.payments = distributeLineAmounts(payment.paymenttypes, sale.prices_sold.sale_price, sale.quantity_sold)
    })

    // A vale is a discount on the sale total, applied once on the first matched sale of its group.
    payments.forEach((payment) => {
      if (!payment.credit?.code || !payment.credit?.amount) return
      const matchedSale = articleInCart.find(sale => !payment.saleIds || payment.saleIds.includes(sale._id))
      if (matchedSale) {
        matchedSale.store_credit_applied = { code: payment.credit.code, amount: payment.credit.amount }
      }
    })

    if (articleInCart) {
      var data = articleInCart.map((a) => ({
        ...a,
        ...dataSale,
        quantity_in_stock: a.quantity_in_stock + a.quantity_sold,
        // status: delivery ? STATUS_SALE.FINISHED : STATUS_SALE.RESERVED,
        // nameSale: name,
        // userId: vendor,
      }))
      
      console.log('🔍 DEBUG handleFinishSell - data final a enviar:', data);
      data.forEach((item, idx) => {
        console.log(`Item ${idx}:`, {
          name: item.name,
          color_selected: item.color_selected,
          size_selected: item.size_selected
        });
      });
      
      // await SaleService.save(store._id, data)
      // setLoadsArticulos(true)
      try {
        const savedSales = await (onCompleteSell && onCompleteSell(data))

        const hasFinishedSale = Array.isArray(data)
          ? data.some((item) => item.status === STATUS_SALE.FINISHED)
          : data?.status === STATUS_SALE.FINISHED;

        if (hasFinishedSale) {
          const savedArray = Array.isArray(savedSales) ? savedSales : [savedSales];
          const ids = Array.from(new Set(
            savedArray
              .map((sale) => sale?.idSale || sale?._id || sale?.id || sale?.saleId)
              .filter(Boolean)
          ));

          try {
            const activePrinter = await PrinterService.getActivePrinter();

            if (ids.length) {
              if (activePrinter?.printerType === 'pdf') {
                await PrinterService.downloadTicketPreviewAsPDF(store._id, ids.join(','));
              } else {
                await PrinterService.printSales(store._id, ids);
              }
            }
          } catch (printError) {
            console.error('Error al imprimir ticket después de guardar venta:', printError);
          }
        }

        setArticleInCart([])
        setNewSale(false)
      } catch (err) {
        console.error('❌ handleFinishSell error:', { status: err?.response?.status, data: err?.response?.data, message: err?.message });
        const errData = err?.response?.data;
        let msg;
        if (typeof errData === 'string' && errData) msg = errData;
        else if (errData?.message) msg = errData.message;
        else if (errData?.error) msg = errData.error;
        else if (errData?.detail) msg = errData.detail;
        else if (errData && typeof errData === 'object') msg = JSON.stringify(errData);
        else msg = err?.message || 'Error al guardar la venta';
        setRifaError(msg);
      } finally {
        setRifaData({ numero_rifa: '', dni: '', telefono: '' })
        setSaving(false)
      }
      return
    }
    setNewSale(false)
  }

  const handleCancelSell = () => {
    setOpenModal(false)
    setSaving(false)
    setNewSale(false)
    setArticleInCart([])
    setRifaData({ numero_rifa: '', dni: '', telefono: '' })
    onCancel && onCancel()
  }

  const hasSaleContent = saving || loading || moreOneArticle || articleInCart?.length > 0 || existingItems.length > 0
  const shouldFullScreen = isMobile && hasSaleContent

  return <>
    <Button
      variant="outlined"
      color="warning"
      startIcon={<AddShoppingCart />}
      onClick={() => setNewSale(true)}
      sx={{
        borderRadius: 2,
        textTransform: 'none',
        boxShadow: 3,
      }}
    >+Venta (F2)</Button>
    <Dialog 
      open={newSale} 
      onClose={() => handleCancelSell()}
      maxWidth={hasSaleContent ? "lg" : "sm"}
      fullWidth={hasSaleContent}
      fullScreen={shouldFullScreen}
      PaperProps={{
        sx: {
          width: shouldFullScreen ? '100%' : hasSaleContent ? 'min(1200px, calc(100% - 64px))' : 'min(560px, calc(100% - 64px))',
          height: shouldFullScreen ? '100dvh' : hasSaleContent ? '92vh' : 'auto',
          maxHeight: shouldFullScreen ? '100dvh' : hasSaleContent ? '92vh' : 'unset',
          overflow: 'hidden',
          display: 'flex',
          margin: 'auto',
        }
      }}
    >
      {/* {saving || loading ? <CircularProgressCustom size={150} /> : newSale && !moreOneArticle &&  */}
      <Box display='flex' flexDirection='column' width='100%' height={hasSaleContent ? '100%' : 'auto'} justifyItems='center' overflow='hidden'>
        <Box sx={{ position: 'sticky', top: 0, zIndex: 2, backgroundColor: 'background.paper' }}>
          <SearchComponent onSearch={handleSearch} width="100%" focusTrigger={searchFocusTrigger} onTabPress={() => nameFieldRef.current?.focus()} />
        </Box>
        {initialName && existingItems.length > 0 && (
          <Box
            sx={{
              mx: 1.5,
              mt: 1,
              p: 1.5,
              maxHeight: { xs: 250, md: 300 },
              overflowY: 'auto',
              borderRadius: 2,
              border: '1px solid rgba(2, 136, 209, 0.35)',
              backgroundColor: 'rgba(2, 136, 209, 0.06)',
            }}
          >
            <Box display='flex' justifyContent='space-between' alignItems='center' gap={1} mb={1}>
              <Box>
                <Typography variant='subtitle1' fontWeight={800}>Pedido de {initialName}</Typography>
                <Typography variant='caption' color='text.secondary'>Estos artículos ya están reservados</Typography>
              </Box>
              <Chip
                size='small'
                color='info'
                label={`$${ccyFormat(existingItems.reduce((sum, item) => sum + ((item.prices_sold?.sale_price || 0) * (item.quantity_sold || 0)), 0))}`}
              />
            </Box>
            {existingItems.map((item, index) => {
              const lineTotal = (item.prices_sold?.sale_price || 0) * (item.quantity_sold || 0);
              const variant = [item.color_selected, item.size_selected].filter(Boolean).join(' / ');
              return (
                <Box key={`${item._id || item.article_id || item.sku}-${index}`} display='flex' justifyContent='space-between' gap={1} py={0.55}>
                  <Typography variant='body2' noWrap sx={{ minWidth: 0 }}>
                    {item.quantity_sold} x {item.name}{variant ? ` · ${variant}` : ''}
                  </Typography>
                  <Typography variant='body2' fontWeight={700} sx={{ flexShrink: 0 }}>${ccyFormat(lineTotal)}</Typography>
                </Box>
              );
            })}
            <Box display='flex' justifyContent='space-between' mt={1} pt={1} borderTop='1px solid rgba(2, 136, 209, 0.25)'>
              <Typography variant='body2' color='text.secondary'>Total con lo nuevo</Typography>
              <Typography variant='subtitle1' fontWeight={900} color='info.dark'>
                ${ccyFormat(existingItems.reduce((sum, item) => sum + ((item.prices_sold?.sale_price || 0) * (item.quantity_sold || 0)), 0) + articleInCart.reduce((sum, item) => sum + ((item.prices_sold?.sale_price || 0) * (item.quantity_sold || 0)), 0))}
              </Typography>
            </Box>
          </Box>
        )}
        {(() => {
          const minimo = activeLote?.config?.monto_minimo ?? 0;
          const cartTotal = articleInCart.reduce((sum, a) => sum + (a.prices_sold?.sale_price || 0) * (a.quantity_sold || 0), 0);
          if (!activeLote || saving || loading || !articleInCart?.length || (minimo > 0 && cartTotal < minimo)) return null;
          return (
          <Box px={1.5} pt={1} pb={0.5}>
            <Button
              fullWidth
              onClick={() => handleOpenRifaDialog()}
              startIcon={rifaAssigned ? <CheckCircleOutlined /> : <ConfirmationNumberOutlined />}
              sx={{
                borderRadius: 2.5,
                textTransform: 'none',
                fontWeight: 800,
                fontSize: '0.97rem',
                py: 1.1,
                px: 2,
                letterSpacing: 0.2,
                ...(rifaAssigned ? {
                  background: 'linear-gradient(90deg, #2e7d32 0%, #43a047 100%)',
                  color: '#fff',
                  boxShadow: '0 4px 14px rgba(46,125,50,0.35)',
                  '&:hover': { background: 'linear-gradient(90deg, #1b5e20 0%, #2e7d32 100%)' },
                } : {
                  background: 'linear-gradient(90deg, #7b4f9e 0%, #c0714a 100%)',
                  color: '#fff',
                  boxShadow: '0 4px 14px rgba(123,79,158,0.35)',
                  animation: 'rifaPulse 2s ease-in-out infinite',
                  '@keyframes rifaPulse': {
                    '0%, 100%': { boxShadow: '0 4px 14px rgba(123,79,158,0.35)' },
                    '50%': { boxShadow: '0 6px 22px rgba(192,113,74,0.55)' },
                  },
                  '&:hover': { background: 'linear-gradient(90deg, #6a3f8e 0%, #b07a5a 100%)' },
                }),
              }}
            >
              {rifaAssigned
                ? `✓ Rifa #${String(rifaData.numero_rifa).padStart(4, '0')} asignada — toca para editar`
                : `🎟 Asignar número de rifa — Lote ${activeLote.lote}`}
            </Button>
            {rifaAssigned && (
              <Box display='flex' justifyContent='flex-end' mt={0.75}>
                <Chip
                  size='small'
                  label='✕ Quitar rifa'
                  onClick={() => setRifaData({ numero_rifa: '', dni: '', telefono: '' })}
                  sx={{
                    fontSize: 12,
                    fontWeight: 700,
                    color: '#9C0006',
                    bgcolor: '#FFC7CE',
                    border: '1px solid #f5a0a8',
                    '&:hover': { bgcolor: '#f5a0a8' },
                  }}
                />
              </Box>
            )}
          </Box>
        );
        })()}
        {saving || loading ? <CircularProgressCustom size={250} /> : !moreOneArticle && articleInCart?.length > 0 && <Box display='flex' flex={1} minHeight={0} overflow={isMobile ? 'auto' : 'hidden'} flexDirection='column'>
          <Box flex={1} minHeight={0} overflow={isMobile ? 'auto' : 'hidden'}>
            <CarritoView
            users={users}
            rows={articleInCart}
            onRemoveItem={handleRemoveItemFromCart}
            onCancel={handleCancel}
            onSell={handleSell}
            width="100%"
            withDescription={false}
            onChangePrice={(typeSale, value, row) => {
              if (TYPE_SALE.MAYOR === typeSale) {
                setArticleInCart(articleInCart.map(r =>
                  r.article_id === row.article_id && row.prices_sold.sale_price === r.prices_sold.sale_price
                    ? {
                      ...r,
                      prices_sold: {
                        ...r.prices_sold,
                        sale_price: r.prices_sold.sale_price - 200,
                      },
                    }
                    : r
                ));
              } else if (TYPE_SALE.COSTO === typeSale) {
                setArticleInCart(articleInCart.map(r =>
                  r.article_id === row.article_id && row.prices_sold.sale_price === r.prices_sold.sale_price
                    ? {
                      ...r,
                      prices_sold: {
                        ...r.prices_sold,
                        sale_price: r.prices?.list_price ?? r.prices_sold?.list_price ?? r.prices_sold.sale_price,
                      },
                    }
                    : r
                ));
              } else if (TYPE_SALE.MENOR === typeSale) {
                setArticleInCart(articleInCart.map(r =>
                  r.article_id === row.article_id && row.prices_sold.sale_price === r.prices_sold.sale_price
                    ? {
                      ...r,
                      prices_sold: {
                        ...r.prices_sold,
                        sale_price: r.prices.sale_price,
                      },
                    }
                    : r
                ));
              } else if (CHANGE.QUANTITY === typeSale) {
                setArticleInCart(articleInCart.map(r =>
                  r.article_id === row.article_id && row.prices_sold.sale_price === r.prices_sold.sale_price
                    ? {
                      ...r,
                      quantity_sold: parseInt(value)
                    }
                    : r
                ));
              } else if (CHANGE.PRICE === typeSale) {
                setArticleInCart(articleInCart.map(r =>
                  r.article_id === row.article_id && row.prices_sold.sale_price === r.prices_sold.sale_price
                    ? {
                      ...r,
                      prices_sold: {
                        ...r.prices_sold,
                        sale_price: parseInt(value),
                      },
                    }
                    : r
                ));
              } else if (CHANGE.VARIANT_COLOR === typeSale) {
                setArticleInCart(prev => prev.map(r =>
                  r.article_id === row.article_id
                    ? { ...r, color_selected: value, size_selected: '' }
                    : r
                ));
              } else if (CHANGE.VARIANT_SIZE === typeSale) {
                setArticleInCart(prev => prev.map(r =>
                  r.article_id === row.article_id
                    ? { ...r, size_selected: value }
                    : r
                ));
              }
            }}
            nameFieldRef={nameFieldRef}
            initialName={initialName}
            existingItems={[]}
          />
          </Box>
        </Box>}
        {rifaError && (
          <Alert
            severity='error'
            variant='filled'
            onClose={() => setRifaError('')}
            sx={{ mx: 2, my: 1, borderRadius: 2, flexShrink: 0 }}
          >
            {rifaError}
          </Alert>
        )}
      </Box>
      <Modal
        open={openModal || moreOneArticle}
        onClose={() => setOpenModal(false)}
        //width="50%"
        Content={() => moreOneArticle ?
          <ProductModal 
            open={moreOneArticle}
            products={articulos}
            onClose={() => { setOpenModal(false); setMoreOneArticle(false) } } 
            onSave={articlesSelected => {
              console.log(articlesSelected)
              addManyToSale(articlesSelected || [])
              setOpenModal(false)
              setMoreOneArticle(false)
              setTimeout(() => {
                setSearchFocusTrigger(prev => prev + 1)
              }, 200)
            }}
          />
          : <FormPaymentType onClose={handleCancelSell} onSubmit={handleFinishSell} storeId={store?._id} payments={[{
            nameSale: dataSale.nameSale || '',
            paymenttypes: getPaymentTypesForForm(),
            total: articleInCart.reduce((sum, art) => sum + (art.quantity_sold * art.prices_sold.sale_price), 0),
            depositPaid: (salesReserved || [])
              .filter(s => s.nameSale === dataSale.nameSale)
              .reduce((sum, s) => sum + Number(s.deposit || 0), 0),
            amount: 0
          }]} />}
      />
    </Dialog>

    {/* Raffle assignment dialog */}
    <Dialog
      open={rifaDialog}
      onClose={() => setRifaDialog(false)}
      maxWidth='xs'
      fullWidth
      PaperProps={{ sx: { borderRadius: 3, overflow: 'hidden' } }}
    >
      {/* Gradient header */}
      <Box sx={{
        background: 'linear-gradient(135deg, #7b4f9e 0%, #c0714a 100%)',
        px: 3, pt: 2.5, pb: 5, textAlign: 'center',
      }}>
        {activeLote && (
          <Chip
            label={`Lote ${activeLote.lote}${activeLote.config?.nombre_negocio ? ' · ' + activeLote.config.nombre_negocio : ''}`}
            size='small'
            sx={{ bgcolor: 'rgba(255,255,255,0.22)', color: '#fff', mb: 1.5, fontSize: 11, fontWeight: 600 }}
          />
        )}
        <Typography variant='h6' sx={{ color: '#fff', fontWeight: 700, letterSpacing: 0.3 }}>
          Asignar número de rifa
        </Typography>
      </Box>

      {/* Floating ticket badge */}
      <Box sx={{ display: 'flex', justifyContent: 'center', mt: -4.5, mb: 0.5, position: 'relative', zIndex: 1 }}>
        <Box sx={{
          width: 90, height: 90, borderRadius: '50%',
          bgcolor: '#fff',
          boxShadow: '0 6px 24px rgba(0,0,0,0.14)',
          border: '3px solid #c0714a',
          display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
          gap: 0.25,
        }}>
          {rifaLoading ? (
            <CircularProgressCustom size={34} />
          ) : (
            <>
              <ConfirmationNumberOutlined sx={{ color: '#c0714a', fontSize: 20 }} />
              <Typography sx={{ fontWeight: 900, color: '#c0714a', fontSize: 18, lineHeight: 1 }}>
                {rifaData.numero_rifa ? String(rifaData.numero_rifa).padStart(4, '0') : '—'}
              </Typography>
            </>
          )}
        </Box>
      </Box>

      <DialogContent sx={{ pt: 2, pb: 1 }}>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          <TextField
            label='Número de rifa'
            type='number'
            fullWidth
            value={rifaData.numero_rifa}
            onChange={(e) => setRifaData((p) => ({ ...p, numero_rifa: e.target.value }))}
            inputProps={{ min: 1 }}
            autoFocus
            disabled={rifaLoading}
            InputProps={{ readOnly: true }}
          />
          <TextField
            label='DNI'
            fullWidth
            required
            value={rifaData.dni}
            onChange={(e) => setRifaData((p) => ({ ...p, dni: e.target.value }))}
            disabled={rifaLoading}
          />
          <TextField
            label='Teléfono'
            fullWidth
            required
            value={rifaData.telefono}
            onChange={(e) => setRifaData((p) => ({ ...p, telefono: e.target.value }))}
            disabled={rifaLoading}
          />
        </Box>
      </DialogContent>

      <DialogActions sx={{ flexDirection: 'column', gap: 0.5, px: 3, pb: 3, pt: 1.5 }}>
        <Button
          variant='contained'
          fullWidth
          size='large'
          disabled={rifaLoading || !rifaData.numero_rifa || !rifaData.dni || !rifaData.telefono}
          onClick={() => setRifaDialog(false)}
          sx={{
            borderRadius: 2, py: 1.4, fontWeight: 700, fontSize: 15,
            background: 'linear-gradient(90deg, #c0714a 0%, #7b4f9e 100%)',
            boxShadow: '0 4px 14px rgba(192,113,74,0.35)',
            '&:hover': { background: 'linear-gradient(90deg, #b07a5a 0%, #6a3f8e 100%)' },
          }}
        >
          Confirmar
        </Button>
        <Button
          size='small'
          onClick={() => { setRifaData({ numero_rifa: '', dni: '', telefono: '' }); setRifaDialog(false); }}
          sx={{ color: 'text.secondary', textTransform: 'none', fontSize: 13 }}
        >
          Continuar sin rifa
        </Button>
      </DialogActions>
    </Dialog>

    {/* Variant selector dialog */}
    {variantDialog && (() => {
      const availableVariants = (variantDialog.article.type_detail || []).filter(v => v.available && v.quantity > 0);
      const selectedVariant = availableVariants.find(v => v.color === selectedColor);
      const canConfirm = !!selectedColor && (!selectedVariant?.sizes?.length || !!selectedSize);
      return (
        <Dialog open onClose={handleCloseVariantDialog} maxWidth="xs" fullWidth>
          <DialogTitle>
            Seleccionar variante
            <Typography variant="body2" color="text.secondary" mt={0.5}>
              {variantDialog.article.article?.name}
            </Typography>
          </DialogTitle>
          <DialogContent dividers>
            <Typography variant="subtitle2" mb={1}>Color</Typography>
            <Box display="flex" flexWrap="wrap" gap={1} mb={2}>
              {availableVariants.map((v) => (
                <Tooltip key={v.color} title={`Stock: ${v.quantity}`}>
                  <Chip
                    label={v.color}
                    onClick={() => { setSelectedColor(v.color); setSelectedSize(''); }}
                    variant={selectedColor === v.color ? 'filled' : 'outlined'}
                    color={selectedColor === v.color ? 'primary' : 'default'}
                    sx={{
                      cursor: 'pointer',
                      ...(v.color && /^#|^rgb/.test(v.color) ? {
                        bgcolor: selectedColor === v.color ? v.color : 'transparent',
                        borderColor: v.color,
                        color: selectedColor === v.color ? '#fff' : 'text.primary',
                      } : {})
                    }}
                  />
                </Tooltip>
              ))}
            </Box>
            {selectedVariant?.sizes?.length > 0 && (
              <>
                <Typography variant="subtitle2" mb={1}>Talle</Typography>
                <Box display="flex" flexWrap="wrap" gap={1}>
                  {selectedVariant.sizes.map((size) => {
                    const sizeDetail = (selectedVariant.size_details || []).find(sd => sd.size === size);
                    const outOfStock = sizeDetail
                      ? (sizeDetail.quantity === 0 || sizeDetail.available === false)
                      : false;
                    return (
                      <Tooltip key={size} title={outOfStock ? 'Sin stock' : sizeDetail ? `Stock: ${sizeDetail.quantity}` : ''}>
                        <span>
                          <Chip
                            label={size}
                            onClick={() => !outOfStock && setSelectedSize(size)}
                            variant={selectedSize === size ? 'filled' : 'outlined'}
                            color={selectedSize === size ? 'secondary' : 'default'}
                            disabled={outOfStock}
                            sx={{ cursor: outOfStock ? 'not-allowed' : 'pointer' }}
                          />
                        </span>
                      </Tooltip>
                    );
                  })}
                </Box>
              </>
            )}
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseVariantDialog}>Cancelar</Button>
            <Button
              variant="contained"
              onClick={handleConfirmVariant}
              disabled={!canConfirm}
            >
              Agregar al carrito
            </Button>
          </DialogActions>
        </Dialog>
      );
    })()}

    <Snackbar
      open={Boolean(rifaError)}
      autoHideDuration={7000}
      onClose={() => setRifaError('')}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
    >
      <Alert severity='error' variant='filled' onClose={() => setRifaError('')} sx={{ width: '100%' }}>
        {rifaError}
      </Alert>
    </Snackbar>
  </>
}

export default NewSale;